/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface UIStore {
    sidebarCollapsed: boolean
    toggleSidebar: () => void
    setSidebarCollapsed: (collapsed: boolean) => void
}

export const useUIStore = create<UIStore>()(
    persist(
        (set) => ({
            sidebarCollapsed: false,

            toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),

            setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
        }),
        {
            name: 'menyxo-ui-state',
        }
    )
)
